import Link from '@/components/utilities/SmartLink';
import { Icon } from '@/components/ui/icon';
import { getGlossaryTermUrl } from '@/utils/glossary-routes';

const GlossaryRelatedTerms = ({ terms, locale, title = 'Příbuzné pojmy' }) => {
  if (!Array.isArray(terms) || terms.length === 0) return null;

  return (
    <div className="border-grey-200 rounded-2xl border bg-white px-6 py-5">
      <div className="text-grey-500 mb-3 text-xs font-bold tracking-[0.08em] uppercase">{title}</div>
      <ul className="flex flex-col">
        {terms.map((term, index) => (
          <li key={term.id} className={index < terms.length - 1 ? 'border-grey-200 border-b' : ''}>
            <Link
              href={getGlossaryTermUrl(term.slug, locale)}
              className="text-grey-900 hover:text-brand-500 flex items-center gap-2.5 py-2.5 text-sm font-medium transition-colors"
            >
              <Icon type="chevronRight" width={14} height={14} className="text-brand-500 shrink-0" />
              {term.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default GlossaryRelatedTerms;
